import { generateClearResourceAction, generateStoreResourceAction } from '../generators/resource.actions';

import * as types from './meeting-shortcuts.types';
import * as constants from './meeting-shortcuts.constants';

export const storeMeetingShortcuts = generateStoreResourceAction<types.IMeetingFolder>(
  constants.STORE_MEETING_SHORTCUT,
);
export const clearMeetingShortcuts = generateClearResourceAction(constants.CLEAR_MEETING_SHORTCUT);

export const storeMeetingShortcutsFolder = generateStoreResourceAction<types.IMeetingFolder | types.IMeetingSubFolder>(
  constants.STORE_MEETING_SHORTCUTS_FOLDER,
);
export const clearMeetingShortcutsFolder = generateClearResourceAction(constants.CLEAR_MEETING_SHORTCUTS_FOLDER);
